module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Radar.js"));
	}, "Radar");
}